import axios from "axios";

/*
 * Contains logic responsible for controlling the archives filter feature.
 */

window.addEventListener("DOMContentLoaded", function() {
    init();
}, false);


function init() {
    var archivesFilterBtn,
        archivesFilterFormContainer,
        archivesFilter,
        advancedArchivesFilterBtn,
        advancedArchivesFilterForm,
        advancedArchivesFilter;

    archivesFilter = document.querySelector(".archives-filter");
    archivesFilterBtn = document.querySelector(".archives-filter-btn");
    if (archivesFilterBtn) {
        archivesFilterFormContainer = document.querySelector(".archives-filter-form-container");
        archivesFilterBtn.addEventListener("click", function(e) {
            if (archivesFilter) {
                archivesFilter.classList.toggle("closed");
                archivesFilter.classList.toggle("open");
            }
            if (archivesFilterFormContainer) {
                archivesFilterFormContainer.classList.toggle("collapsed");
            }
        }, false);
    }

    advancedArchivesFilter = document.querySelector(".advanced-archive-filters");
    advancedArchivesFilterBtn = document.querySelector(".advanced-archives-filter-btn");
    if (advancedArchivesFilterBtn) {
        advancedArchivesFilterForm = document.querySelector(".advanced-archives-filter-form-container");
        advancedArchivesFilterBtn.addEventListener("click", function(e) {
            e.preventDefault();
            if (advancedArchivesFilter) {
                advancedArchivesFilter.classList.toggle("closed");
                advancedArchivesFilter.classList.toggle("open");
            }
            if (advancedArchivesFilterForm) {
                advancedArchivesFilterForm.classList.toggle("collapsed");
            }
        }, false);
    }

    var archivesFilterForm = document.querySelector(".archives-filter-form");
    var archivesFilterFormResetBtn = document.querySelector(".archives-filter-form-btns > button[type='reset']");
    var archivesFilterFormSubmitBtn = document.querySelector(".archives-filter-form-btns > button[type='submit']");
    if (archivesFilterFormResetBtn) {
        archivesFilterFormResetBtn.addEventListener("click", function (e) {
            e.preventDefault();
            if (archivesFilterForm) {
                var formInputFields = archivesFilterForm.querySelectorAll(".archives-filter-form-field > input");
                formInputFields.forEach(inputField => inputField.value = '');
                var formSelectFieldOptions = archivesFilterForm.querySelectorAll(".archives-filter-form-field > select > option");
                formSelectFieldOptions.forEach(selectOption => selectOption.selected = false);
                if (archivesFilterFormSubmitBtn) {
                    archivesFilterFormSubmitBtn.click();
                }
            }
        }, false);
    }

    let activeFiltersBar = document.querySelector('.active-filters-bar')
    if (activeFiltersBar) {
        showActiveFilters(activeFiltersBar)
    }
}

function showActiveFilters(activeFiltersBar) {
    const FilterFields = ['path', 'status', 'sha1', 'filename', 'start_date', 'end_date']
    let params = new URLSearchParams(document.location.search)
    let filterBlueprint = activeFiltersBar.querySelector('.active-filter')
    FilterFields.forEach(field => {
        let fieldValue = params.get(field)
        if (fieldValue != null && fieldValue !== '') {
            if (params.getAll(field).length > 1) {
                let fieldValues = params.getAll(field)
                fieldValues.forEach(value => {
                    let newActiveFilter = filterBlueprint.cloneNode(true)
                    let activeFilterField = newActiveFilter.querySelector('.filter-field')
                    let activeFilterValue = newActiveFilter.querySelector('.filter-value')
                    activeFilterField.innerHTML = field + ':'
                    activeFilterValue.innerHTML = value
                    newActiveFilter.classList.remove('u-vh')
                    newActiveFilter.addEventListener('click', e => {
                        params.delete(field, value)
                        document.location.search = params.toString()
                    })
                    activeFiltersBar.appendChild(newActiveFilter)
                })
            } else if (params.getAll(field).length === 1) {
                if (field === 'path') {
                    field = 'url'
                }
                let newActiveFilter = filterBlueprint.cloneNode(true)
                let activeFilterField = newActiveFilter.querySelector('.filter-field')
                let activeFilterValue = newActiveFilter.querySelector('.filter-value')
                activeFilterField.innerHTML = field + ':'
                activeFilterValue.innerHTML = fieldValue
                newActiveFilter.classList.remove('u-vh')
                newActiveFilter.addEventListener('click', e => {
                        params.delete(field, fieldValue)
                        document.location.search = params.toString()
                })
                activeFiltersBar.appendChild(newActiveFilter)
            }
        }
    })
}
